shvenergy.processteaser = function ($) {
    "use strict";

    let processTeasers = document.querySelectorAll(".process-teaser__overview");
    let ulWidth = 0, positionLeft = 0, maxTranslateX = 0, current = 0;
    let processTeaserNavigation = $(".process-teaser__navigation");
    let processTeaser, nextButton, previousButton, processTeaserList, currentProcessTeaser;

    function init() {
        processTeasers.forEach((processTeaserLi) => {
            processTeaser = processTeaserLi;
            processTeaser.setAttribute('current', 0);
            previousButton = processTeaser.nextElementSibling.firstElementChild;
            nextButton = processTeaser.nextElementSibling.lastElementChild;
            processTeaserList = processTeaser.firstElementChild.getElementsByTagName("li");

            nextButton.addEventListener("click", goToNextButton);
            previousButton.addEventListener("click", goToPreviousButton);

            onResize();
            processTeaserResize();

            $(window).on("resize", onResize);
            $(window).on("resize", processTeaserResize);
            $(window).on("scroll", onResize);
        });
    }

    function goToNextButton(e) {
        currentProcessTeaser = e.currentTarget.parentElement.previousElementSibling;
        current = currentProcessTeaser.getAttribute('current');
        currentProcessTeaser.setAttribute('current', ++current);
        goToProcessTeaser();
    }

    function processTeaserResize() {
        if (window.matchMedia("(max-width: 639px)").matches) {
            processTeaserNavigation.css({ opacity: 0 })
        } else {
            processTeaserNavigation.css({ opacity: 1 })
        }
    }

    function goToPreviousButton(e) {
        currentProcessTeaser = e.currentTarget.parentElement.previousElementSibling;
        current = currentProcessTeaser.getAttribute('current');
        currentProcessTeaser.setAttribute('current', --current);
        goToProcessTeaser();
    }

    function onResize() {
        processTeasers.forEach(function (processTeaserLi) {
            currentProcessTeaser = processTeaserLi;
            goToProcessTeaser();
        });
    }

    function goToProcessTeaser() {
        if (currentProcessTeaser) {
            processTeaser = currentProcessTeaser;
            processTeaserList = processTeaser.firstElementChild.getElementsByTagName("li");
            previousButton = processTeaser.nextElementSibling.firstElementChild;
            nextButton = processTeaser.nextElementSibling.lastElementChild;
        }

        let wrapWidth = processTeaser.getBoundingClientRect().width;
        let offset = $(".process-teaser__list__item ").outerWidth() * processTeaser.getAttribute('current');
        ulWidth = calcUlWidth();
        maxTranslateX = ulWidth - wrapWidth;

        if (offset > maxTranslateX) {
            offset = maxTranslateX + 1;
        }

        offset = parseInt(offset);
        processTeaser.scrollLeft = offset;

        if (offset > 0) {
            toggleBtn(previousButton, true, offset);
        } else {
            toggleBtn(previousButton, false, offset);
        }

        if (offset >= maxTranslateX) {
            toggleBtn(nextButton, false, offset);
        } else {
            toggleBtn(nextButton, true, offset);
        }
    }

    function toggleBtn(btn, show, offset) {
        if (offset < 0) {
            btn.style.display = "none";
        } else {
            btn.style.display = "block";
        }
        if (show) {
            btn.classList.remove("disable");
        } else {
            btn.classList.add("disable");
        }
    }

    function calcUlWidth() {
        var width = 0;
        var wrapWidth = processTeaser.getBoundingClientRect().width;
        Array.from(processTeaserList).forEach(function (processteaserListItem) {
            if (width === 0) {
                positionLeft = processteaserListItem.clientLeft;
            }
            width += processteaserListItem.clientWidth;
        });

        if (width > wrapWidth) {
            width += positionLeft;
        }
        
        return width;
    }

    init();

}(jQuery);
